import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const Disclaimer = () => {
  return (
    <div className="min-h-screen py-20 bg-gradient-to-br from-hr-warm-bg via-white to-hr-purple-light/10 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-hr-purple/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-hr-teal/5 rounded-full blur-3xl animate-float-slow" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12 animate-fade-in-up">
          <header className="mb-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-amber-100 mb-6 animate-bounce-subtle">
              <AlertTriangle className="h-8 w-8 text-amber-600" />
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-hr-text-primary mb-4 animate-fade-in-up stagger-1" style={{ opacity: 0 }}>
              Disclaimer
            </h1>
            <p className="text-hr-text-muted animate-fade-in-up stagger-2" style={{ opacity: 0 }}>Last Updated: 1/15/2026</p>
          </header>

          <div className="prose prose-lg max-w-none text-hr-text-secondary animate-fade-in-up stagger-3" style={{ opacity: 0 }}>
            <p className="lead">
              The information provided by HR Nest, LLC ("HR Nest," "Company," "we," "us," or "our") on this website and through any related programs, services, events, coaching, workshops, downloadable materials, templates, communications, or resources (collectively, the "Website") is provided for general informational and educational purposes only.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Not Legal Advice</h2>
            <p className="font-semibold text-hr-purple">HR Nest does not provide legal advice.</p>
            <p>
              Nothing on this Website, or in any materials or services offered by HR Nest, should be construed as legal advice, legal opinions, or a substitute for advice from a qualified attorney. HR Nest is not a law firm and does not provide legal representation.
            </p>
            <p>
              Employment laws, labor regulations, and workplace policies vary by jurisdiction and are subject to change. Because individual circumstances differ, you should always consult with a licensed attorney or appropriate legal professional before making decisions related to employment matters, workplace disputes, contracts, compliance, or legal rights.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Not Professional or Financial Advice</h2>
            <p>
              In addition to legal advice, HR Nest does not provide financial, tax, medical, mental health, or other licensed professional advice unless expressly stated in writing.
            </p>
            <p>
              Any guidance related to careers, resumes, interviews, workplace communication, HR practices, or professional development is educational in nature and should not replace advice from qualified professionals.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">No Guarantees</h2>
            <p>
              While HR Nest strives to provide accurate, practical, and helpful information, we make no guarantees regarding outcomes, employment, promotions, compensation, career advancement, business success, or results of any kind.
            </p>
            <p>
              Results depend on many factors, including individual effort, experience, market conditions, and external circumstances beyond our control.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Personal Responsibility</h2>
            <p>
              By using this Website, you acknowledge that you are responsible for your own decisions, actions, and results. You agree that HR Nest is not liable for any outcomes resulting from your reliance on information provided through the Website.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Third-Party Information</h2>
            <p>
              This Website may reference or link to third-party resources, tools, or websites. HR Nest does not control, endorse, or guarantee the accuracy of third-party information and is not responsible for their content, policies, or practices.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, HR Nest shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from your use of, or reliance on, the Website or its content.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Contact Us</h2>
            <p>If you have questions about this Disclaimer, please contact:</p>
            <p>
              HR Nest, LLC<br />
              📧 Email: HRnestllc@gmail.com
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Disclaimer;
